import React from "react";
import Header from "./header/Header.js";
import { useTheme } from "../contexts/ThemeContext.js";
import Footer from "./footer/Footer.js";

function InnerLayout({ children }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <>
      <Header theme={theme} toggleTheme={toggleTheme} />
      {children}
    <Footer/>
    </>
  );
}

export default InnerLayout;
